export default __webpack_public_path__ + "static/media/m-40.60c42359.svg";